var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-placeholder',{scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('font-awesome-icon',{attrs:{"icon":"poll","fixed-width":""}})]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.$t('survey'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }